import { useTranslation } from "react-i18next";
import { Ic } from "../shared";

/** Pill piano / trial in topbar — include trial scaduto e ultimo giorno. */
export default function MerchantPlanPills({ shop, onChoosePlan }) {
  const { t } = useTranslation("common");
  if (shop?.is_agency_managed) {
    return (
      <span
        className="pill"
        style={{
          background: "#f0f4ff",
          color: "#4338ca",
          borderColor: "#c7d2fe",
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
        }}
      >
        {Ic.building}
        {t("pill.agencyManaged")}
      </span>
    );
  }
  const p = shop?.plan || "trial";
  const exp = shop?.trial_expires_at;
  const trialEnd = exp ? new Date(exp) : null;
  const trialExpired = p === "trial" && trialEnd && trialEnd.getTime() < Date.now();
  const daysLeft =
    exp && trialEnd && !trialExpired
      ? Math.max(0, Math.ceil((trialEnd.getTime() - Date.now()) / (1000 * 60 * 60 * 24)))
      : null;
  const trialLastDayActive = p === "trial" && trialEnd && !trialExpired && daysLeft === 0;
  const cta = (
    <span
      className="pill"
      style={{ cursor: "pointer", background: "#0A85CF", color: "#fff", borderColor: "#0A85CF" }}
      onClick={onChoosePlan}
    >
      {t("pill.choosePlan")}
    </span>
  );
  if (p === "trial") {
    if (trialExpired) {
      return (
        <>
          <span className="pill" style={{ background: "#fff5f5", color: "#c62828", borderColor: "#ffcdd2" }}>
            {t("pill.trialExpired")}
          </span>
          {cta}
        </>
      );
    }
    if (trialLastDayActive) {
      return (
        <>
          <span className="pill" style={{ background: "#fff7ed", color: "#ea580c", borderColor: "#fed7aa" }}>
            {t("pill.trialLastDay")}
          </span>
          {cta}
        </>
      );
    }
    return (
      <>
        <span className="pill" style={{ background: "#fff7ed", color: "#ea580c", borderColor: "#fed7aa" }}>
          {t("pill.trial")}
          {daysLeft !== null ? t("pill.trialDays", { count: daysLeft }) : ""}
        </span>
        {cta}
      </>
    );
  }
  if (p !== "cancelled") {
    return (
      <span className="pill green" style={{ textTransform: "capitalize" }}>
        {t("pill.planNamed", { plan: p })}
      </span>
    );
  }
  return (
    <span
      className="pill"
      style={{ cursor: "pointer", background: "#0A85CF", color: "#fff", borderColor: "#0A85CF" }}
      onClick={onChoosePlan}
    >
      {t("pill.reactivate")}
    </span>
  );
}
